import React from 'react';
function MultipleChoiceViewMode(props) {
    const buildChoicesContainer = () => {
        const questionId = props.questionData.id;
        const choices = props.questionData.choices;

        return choices.map((choice, index) => {
            const uniqueKey = "question_" + questionId + "_choice_" + index;
            return (
                <label key={uniqueKey} className="questionaire__builder__question__form__check" htmlFor={questionId + "_" + choice.value}>
                    <input className="questionaire__builder__question__form__check__input" type="checkbox" name={"question_" + questionId} id={questionId + "_" + choice.value}/>
                    <span className="questionaire__builder__question__form__check__check"> </span>
                    <span className="questionaire__builder__question__form__check__text">{choice.label}</span>
                </label>
            );
        });
    };

    return (
        <div className="questionaire__builder__question__form">
            {buildChoicesContainer()}
        </div>
    );
}

export default MultipleChoiceViewMode;
